import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-00907430"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "swiperL"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "desc"
};
const _hoisted_4 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_swiper_slide = _resolveComponent("swiper-slide");
  const _component_swiper = _resolveComponent("swiper");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_swiper, {
    class: "swiper",
    navigation: true,
    modules: $setup.modules,
    "slides-per-view": 3,
    "space-between": 50,
    onSwiper: $setup.onSwiper,
    onSlideChange: $setup.onSlideChange
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.list, (item, index) => {
      return _openBlock(), _createBlock(_component_swiper_slide, {
        key: index
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass(["list-item", [$props.className]]),
          style: _normalizeStyle({
            'background': item.bg ? `url(${item.bg})` : ''
          })
        }, [_createElementVNode("div", _hoisted_2, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(item.desc), 1), item.img ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: item.img,
          alt: ""
        }, null, 8, _hoisted_4)) : _createCommentVNode("", true)], 6)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }, 8, ["modules", "onSwiper", "onSlideChange"])]);
}